import { Component } from '@angular/core';

@Component({
  selector: 'app-content-logo',
  templateUrl: './content-logo.component.html',
})
export class ContentLogoComponent {}
